import React, { Component } from 'react';
import {
  Image,
  ImageBackground,
  Platform,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  Button,
  View,
  Linking,
} from 'react-native';

import FirebaseUsers from '../firebase/firebase_users.js'

import EonnTitle from '../components/title';
import EonnButton from '../components/button';
import EonnLink from '../components/link';
import EonnField from '../components/field';
import PhoneField from '../components/phone_field';
import EonnCheckbox from '../components/checkbox';
import { mstyles } from '../constants/MainStyles';
import common from '../common';

export default class Screen extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      showRequired: false,
      err: "",
      selectedCountryCode: "+1", // Default to US
      smsConsent: false,
    };
    
    // Initialize country code if not present
    if (!global.user.countryCode) {
      global.user.countryCode = "+1";
    }
    
    // Extract country code from phone number if it exists
    const countryCodes = [
      { code: "+1", country: "US/Canada" },
      { code: "+44", country: "UK" },
      { code: "+61", country: "Australia" },
      { code: "+91", country: "India" },
      { code: "+33", country: "France" },
      { code: "+34", country: "Spain" },
      { code: "+49", country: "Germany" },
      { code: "+52", country: "Mexico" },
      { code: "+55", country: "Brazil" },
      { code: "+81", country: "Japan" },
      { code: "+82", country: "South Korea" },
      { code: "+86", country: "China" },
      { code: "+234", country: "Nigeria" },
    ];
    
    if (global.user.phone && global.user.phone.startsWith('+')) {
      // Find the matching country code from our list
      const matchedCountry = countryCodes.find(item => 
        global.user.phone.startsWith(item.code));
      
      if (matchedCountry) {
        // Set the country code
        global.user.countryCode = matchedCountry.code;
        this.state.selectedCountryCode = matchedCountry.code;
        
        // Remove the country code from the phone number
        global.user.phone = global.user.phone.substring(matchedCountry.code.length);
      }
    }
    
    console.log(global.user);
  }

  render() {
    return (
      <ScrollView style={mstyles.sContainer} contentContainerStyle={mstyles.sContent}>
        <EonnTitle>Complete your profile</EonnTitle>
        {this.state.err
          ? <Text style={mstyles.err}>{this.state.err}</Text>
          : null
        }
        <EonnField
          onChange={value => Object.assign(global.user,{ name:value }) }
          showRequired={this.state.showRequired}
          value={global.user.name}
          >Your Name</EonnField>
        {!global.user.uid && <EonnField
          onChange={value => Object.assign(global.user,{ email:value }) }
          showRequired={this.state.showRequired}
          value={global.user.email}
          >Your Email</EonnField> }
          
        <PhoneField
          phoneValue={global.user.phone}
          countryCode={global.user.countryCode || "+1"}
          onPhoneChange={value => Object.assign(global.user, { phone: value })}
          onCountryCodeChange={value => {
            Object.assign(global.user, { countryCode: value });
            this.setState({ selectedCountryCode: value });
          }}
          showRequired={this.state.showRequired}
        >
          Your Phone Number
        </PhoneField>
        {!global.techLinkBid?.t_uid
          ? <Text style={[mstyles.text,{fontSize:15, width:500, maxWidth: '85%', marginBottom:0}]}>Enter your number to get notified when an auto mechanic is ready to help!</Text>
          : <Text style={[mstyles.text,{fontSize:15, width:500, maxWidth: '85%', marginBottom:0}]}>Enter your number to get notified when {global.techLinkBid.t_name} is ready to help!</Text>
        }
        
        <EonnCheckbox
          checked={this.state.smsConsent}
          onChange={value => this.setState({ smsConsent: value })}
          showRequired={this.state.showRequired}
          labelStyle={{fontSize:13, lineHeight:18}}
        >
          By checking this box, I agree to receive SMS messages from Auto TeleTech with updates on my video consultation. Message frequency varies (approximately 2-5 messages per consultation). Message and data rates may apply. Reply STOP to opt-out. By continuing, you agree to our 
          {" "}<Text accessibilityRole="link" style={{ textDecorationLine: 'underline' }} onPress={() => Linking.openURL('https://www.autoteletech.com/terms.html')}>Terms</Text>
          {" "}and{" "}
          <Text accessibilityRole="link" style={{ textDecorationLine: 'underline' }} onPress={() => Linking.openURL('https://www.autoteletech.com/privacy.html')}>Privacy Policy</Text>.
        </EonnCheckbox>
      
        <EonnButton
          loading={this.state.loading}
          navigationProps={this.props.navigation}
          showRequired={() => this.setState({ showRequired: true })}
          required={() => [
            global.user.name,
            global.user.phone,
            this.state.smsConsent,
          ]}
          onPress={() => {
              const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

              // Clean the phone number to remove formatting characters
              let cleanPhone = global.user.phone.replace(/[\s()-\.]/g, '');

              console.log("cleanPhone", cleanPhone);
              
              // Validate phone is just digits
              if (!/^[0-9]{6,12}$/.test(cleanPhone)) {
                this.setState({ err: "Please enter a valid phone number without the country code" });
                return;
              }
              if (emailRegex.test(global.user.email)) {
                global.user.phone = global.user.countryCode + cleanPhone;
                common.newConsult()
                .then(() => {
                  this.props.navigation.navigate("C_Request0");
                })
                .catch((error) => {
                  console.error("Error creating consultation:", error);
                  this.setState({ err: "Failed to create consultation" });
                });
              } else { 
                this.setState({ err: "Invalid email" });
              }
              
          }}
          >
          Next</EonnButton>
      </ScrollView>
    );
  }
}